var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRating(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 29,
    viewBox: "0 0 56 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.4774 18.251L42.5004 11.0354L32.8368 9.5555C32.5929 9.51834 32.3838 9.36247 32.28 9.14089L28 0L23.7201 9.14089C23.6162 9.36247 23.4076 9.51834 23.1632 9.5555L13.4996 11.0354L20.5227 18.251C20.6834 18.4159 20.7566 18.6461 20.7196 18.8731L19.0721 29L27.6396 24.2526C27.8605 24.1303 28.14 24.1303 28.3609 24.2526L36.928 29L35.28 18.8727C35.2434 18.6461 35.3166 18.4159 35.4774 18.251Z",
    fill: "#FFCA43"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9786 9.69461L43.2401 1.64031L39.76 9.13862L44.1303 9.80789C44.7002 9.89534 44.9594 10.614 44.5485 11.0354L36.7956 19.0004L37.8348 25.3859L42.9416 23.1502C43.1521 23.0591 43.4032 23.0709 43.6032 23.1823L51.0883 27.366L49.6454 18.4213C49.6092 18.1961 49.6815 17.9673 49.8405 17.8024L56 11.4192L47.5354 10.111C47.2906 10.0734 47.082 9.91709 46.9786 9.69461Z",
    fill: "#FFCA43"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2044 19L11.4515 11.0354C11.0415 10.6145 11.2994 9.89534 11.8697 9.80789L16.24 9.13862L12.7599 1.64031L9.02142 9.69461C8.918 9.91709 8.70936 10.0734 8.46458 10.111L0 11.4192L6.15955 17.8028C6.31852 17.9678 6.39078 18.1966 6.35465 18.4218L5.06981 26.3864L12.4609 23.1502C12.661 23.0632 12.8895 23.0677 13.0859 23.1628L18.1268 25.6224L19.2044 19Z",
    fill: "#FFCA43"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRating);
export default __webpack_public_path__ + "static/media/rating.c398d68bfbb7fbeec378cc0c27feca03.svg";
export { ForwardRef as ReactComponent };